import React from 'react';

import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {ButtonVariant} from 'components/ui-kit/Button';
import {IS_DEMO, IS_NG} from 'core/constants/env';
import {
    isFormModalOpenChanged,
    isModalOpenChanged,
    isRecallModalOpenChanged,
} from 'models/registries/gtinsGrid/upload';

import {UserPermission, UserRoles} from 'types';

import {ControlsWrapper, CreateButton, RecallButton} from './styled';

export const Controls = () => {
    const {t} = useTranslation();
    const IS_NG_DEMO = IS_NG && IS_DEMO;
    return (
        <ControlsWrapper>
            {!IS_NG_DEMO && (
                <PermissionAccess permissions={[UserPermission.GTIN_CREATE]}>
                    <CreateButton
                        variant={ButtonVariant.Normal}
                        onClick={() => isModalOpenChanged(true)}
                    >
                        {t('pages.registries.gtins.create')}
                    </CreateButton>
                </PermissionAccess>
            )}
            <PermissionAccess permissions={[UserPermission.GTIN_CREATE]}>
                <CreateButton
                    variant={ButtonVariant.Normal}
                    onClick={() => isFormModalOpenChanged(true)}
                >
                    {t('pages.registries.gtins.createForm')}
                </CreateButton>
            </PermissionAccess>
            <PermissionAccess permissions={[]} roleAccess={[UserRoles.ROLE_MPL_OPERATOR_ADMIN]}>
                <RecallButton
                    variant={ButtonVariant.Outline}
                    onClick={() => {
                        isRecallModalOpenChanged(true);
                    }}
                >
                    {t('pages.registries.recall')}
                </RecallButton>
            </PermissionAccess>
        </ControlsWrapper>
    );
};
